import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import values from 'lodash/values';
import Accordion from '@Pages/ProfileSettings/Preferences/components/Accordion';
import { ButtonWithIcon } from '@els/els-react--button';
import { Checkbox } from '@els/els-react--checkbox';
import PreferredSuppliersSectionHeadingOpened from './PreferredSuppliersHeadingOpened';
import PreferredSuppliersSectionHeadingClosed from './PreferredSuppliersHeadingClosed';
import useSearch from './useSearch';

import './PreferredSuppliers.scss';

function PreferredSuppliersSection({
  open,
  onOpen = () => {},
  onClose = () => {},
  onReset = () => {},
  optionsMap,
  checkedOptionsMap,
  onChange = () => {},
  onSave = () => {},
}) {
  const isOptionChecked = ({ name }) => get(checkedOptionsMap, name, false);
  const optionsList = useMemo(() => values(optionsMap), [optionsMap]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const checkedOptionsList = useMemo(() => optionsList.filter(isOptionChecked), [optionsList, checkedOptionsMap]);
  const [searchValue, setSearchValue, searchedOptions] = useSearch(optionsList);
  return (
    <Accordion
      className="preferred-suppliers-accordion-item"
      open={open}
      heading={
        open ? (
          <PreferredSuppliersSectionHeadingOpened
            checkedCount={get(checkedOptionsList, 'length')}
            onClose={onClose}
            onReset={onReset}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
        ) : (
          <PreferredSuppliersSectionHeadingClosed onOpen={onOpen} checkedOptionsList={checkedOptionsList} />
        )
      }
      body={
        <div className="profile-settings-accordion-row__content">
          <div className="preferences-accordion-item__wrapper">
            <div className="preferred-suppliers-accordion-item__suppliers-list">
              {searchedOptions.map(({ name, label }) => (
                <Checkbox
                  key={name}
                  data-e2e={`preferred-supplier-${name}`}
                  label={label}
                  onChange={(event) => {
                    onChange(name, event.target?.checked);
                  }}
                  checked={isOptionChecked({ name })}
                  id={`preferred-supplier-${name}`}
                />
              ))}
            </div>
          </div>
          {open ? (
            <div className="profile-settings-accordion-row__content_button u-els-margin-top">
              <ButtonWithIcon
                data-e2e="preferred-suppliers-save"
                type="primary"
                size="small"
                sprite="ChevronRight"
                linkIconSize="s"
                iconRight
                onClick={onSave}
                className="preferred-suppliers-accordion-item__save-button e2e-preferred-suppliers-save">
                Save
              </ButtonWithIcon>
            </div>
          ) : null}
        </div>
      }
    />
  );
}

PreferredSuppliersSection.propTypes = {
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onReset: PropTypes.func,
  optionsMap: PropTypes.object.isRequired,
  checkedOptionsMap: PropTypes.object,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
};

export default PreferredSuppliersSection;
